import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';

/**
 * Registers the ghost-related attributes on the User model. These are only
 * ever populated in an admin's API payload, so on the forum side they read
 * as undefined/false for normal users.
 */
export default function extendUser() {
  User.prototype.isGhost = Model.attribute('isGhost');
  User.prototype.ghostedAt = Model.attribute('ghostedAt', Model.transformDate);
  User.prototype.ghostedById = Model.attribute('ghostedById');
}
